import ConversationStatus from '@/models/Conversations/ConversationStatus';

export default class ConversationStatusViewModel {
    name: string;
    value: ConversationStatus;

    public constructor(name: string, value: ConversationStatus) {
        this.name = name;
        this.value = value;
    }
}